export default {"src":"https://fishbrain.com/_next/static/media/delaware.3a99f549.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};